<template>
  <div class="page container">
    <!--  -->
    <div class="container-water-fall galleries-list">
      <waterfall :col='col' :data="data" @loadmore="loadmore" @scroll="scroll" :height="waterfall_h">
        <template>
          <div class="cell-item gallery-item" v-for="(item,index) in data" :key="index">
            <div class="gallery-cover" @click="bindToDetail" :data-id="item.id" :data-name="item.title">
              <template v-if="!item.filter_id || item.filter_id[0]==0">
                <img :src="hostUrl + item.picture" class="cover-img" mode="widthFix">
              </template>
              <template v-else>
                <img :src="hostUrl + item.picture" class="cover-img" mode="widthFix">
                <img src="~@static/ugc/creation/filter/mask-1.png" class="filter-mask" mode="aspectFill">
                <img src="~@static/ugc/creation/filter/top-1.png" class="filter-top" mode="widthFix">
                <img src="~@static/ugc/creation/filter/bottom-1.png" class="filter-bottom" mode="widthFix">
              </template>
            </div>
            <div class="gallery-content-wrapper">
              <div class="plan-title-wrapper">
                <div class="tit"><div class="inner">{{item.name}}</div></div>
                <div class="location-wrapper" v-if="item.distance>0">
                  <img mode="widthFix" src="~@static/ugc/list/icon-spot.png">{{(item.distance / 1000).toFixed(1)}}KM
                </div>
              </div>
              <div class="gallery-title" @click="bindToDetail" :data-id="item.id" :data-name="item.title">{{item.title}}</div>
              <div class="item-wrapper">
                <div class="user-wrapper">
                  <img :src="item.headimgurl==''? require('@static/fundingnew/register/avatar-default.png') : item.headimgurl">
                  {{item.nickname}}
                </div>
                <div class="like-wrapper">
                  <div class="text">{{item.like_count}}</div>
                  <img src="~@static/ugc/list/icon-un-like.png" mode="widthFix">
                </div>
              </div>
            </div>
            <div class="status-bar">
              <img src="~@static/fundingnew/profile/gallery/icon-not-pass.png" class="cover-img" v-if="item.status==2">
              <img src="~@static/fundingnew/profile/gallery/icon-pass.png" class="cover-img" v-if="item.status==1">
              <img src="~@static/fundingnew/profile/gallery/icon-review.png" class="cover-img" v-if="item.status==0">
            </div>
          </div>
        </template>
      </waterfall>
      <!-- <loading :show="loading" /> -->
    </div>

    <div class="scroll-top-btn" @click="scrollToTop">
      <img class="icon-top" src="~@static/funding/icon-top.png">
    </div>
    <div class="pop-award" v-if="isShowAward">
      <div class="pop-inner">
        <div class="text" v-html="`上传照片<br>点赞数排名前十名将获得神秘福利`"></div>
        <div class="btn-submit" @click="bindToClose">知道啦</div>
      </div>
    </div>
    <img class="btn-add" src="~@static/ugc/list/btn-add.png" @click="bindToCreate">

  </div>
</template>

<script>
import { mapState } from 'vuex'
const geolocation = new qq.maps.Geolocation()
import { verify, storage, tools } from '@/utils'
import { behavior } from '@/utils/behavior'

export default {
  data() {
    return {
      hostUrl: this.$apiConfig.host,
      isSearch: false,
      isSort: false,
      isFilter: false,
      filterParam: {
        page: 1,
        per_page: 12,
        lat: 0,
        lng: 0,
      },
      data: [],
      col: 2,
      loading: false,
      isFinish: false,
      planId: 0,
      waterfall_h: '0px',
      isShowAward: false,
      plans: [],
    }
  },
  components: {},
  computed: {
    itemWidth() {
      return 138 * 0.5 * (document.documentElement.clientWidth / 375)
    },
    gutterWidth() {
      return 9 * 0.5 * (document.documentElement.clientWidth / 375)
    },
  },
  async created() {
    let pos = {}
    // let ugcVisitCount = storage.getLocalData('ugcVisitCount') || 0
    // if (ugcVisitCount < 3) {
    //   storage.setLocalData('ugcVisitCount', Number(ugcVisitCount) + 1, 604700)
    //   this.isShowAward = true
    // } else {
    //   this.isShowAward = false
    // }
    // setTimeout(() => {
    //   this.bindToClose()
    // }, 4000)

    geolocation.getLocation(
      pos => {
        this.filterParam.lat = pos.lat
        this.filterParam.lng = pos.lng
        //
        this.requestGalleries()
      },
      fail => {
        this.requestGalleries()
        if (fail.code === 1) {
          console.log('拒绝定位权限')
        }
      },
    )
  },
  mounted() {
    var self = this
    let h2 = document.documentElement.clientHeight
    this.waterfall_h = Number(h2 - 60) + 'px'
    // 分享
    if (verify.isWeixin()) {
      let shareInfo = {
        title: '绝对夜计划',
        desc: '绝对赛博夜计划，最高赢取5万元派对金，邀你一起造',
        imgUrl: this.$apiConfig.domain + '/static/funding_cpunk/share.png?v=1',
      }
      let p = tools.parseParams(this.$route.query)
      this.WXConfig.wxShowMenu(`${this.$apiConfig.domain}/welcome?${p}`, shareInfo)
    }
  },
  methods: {
    bindToClose() {
      this.isShowAward = false
    },
    requestGalleries: function () {
      const _self = this
      this.$request
        .get(this.$apiConfig.myUgc, { params: this.filterParam })
        .then(res => {
          const resData = res.data
          if (resData.code == 0 && resData.data) {
            const { totalCount, pageCount, currentPage } = resData.data._meta
            if (pageCount === currentPage) {
              this.isFinish = true
            } else {
              this.filterParam.page += 1
            }

            if (pageCount === 0) {
              this.isFinish = false
              this.filterParam.page = 1
            }

            this.data = this.data.concat(resData.data.items)
          } else {
            console.log(res.msg)
          }
          this.loading = false
        })
        .catch(e => {
          console.log(e)
        })
    },
    bindSearchTap() {
      this.isSearch = true
    },
    bindSearchChange(e) {
      let filterParam = this.filterParam
      filterParam.page = 1
      this.filterParam = filterParam
      this.data = []
      this.isFinish = false
      this.requestGalleries()
    },
    bindSearchBlur() {
      this.isSearch = false
    },
    bindToSort(e) {
      this.isSort = !this.isSort
      this.isFilter = false
    },
    scroll(data) {
      // console.log(data)
    },

    loadmore(num) {
      if (this.loading || this.isFinish) {
        return
      }
      this.loading = true
      this.requestGalleries()
    },
    scrollToTop: function (e) {
      document.querySelector('#vueWaterfall').scrollTop = 0
    },

    bindToCreate: function (e) {
      this.$router.push('/scene/intro')
      _jcq.push(['_track', 'ugc_uploadclick'])
      behavior({ behavior_code: 'prc_bhv_abs_personalcenter_bc6' })
    },
    bindToDetail(e) {
      let { id } = e.target.dataset
      this.$router.push(`/fundingnew/my/gallery/detail/${id}`)
    },
    //
    bindToFilter() {
      this.isFilter = !this.isFilter
      this.isSort = false
    },

    bindToChangeSort(e) {
      let filterParam = this.filterParam
      let type = e.target.dataset.type
      filterParam.order_type = type
      filterParam.page = 1
      this.filterParam = filterParam
      this.sortType = type
      this.isSort = false
      this.data = []
      this.isFinish = false
      this.requestGalleries()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/ugc/list.scss';
.scroll-top-btn {
  bottom: pxtow(34);
}
.btn-add {
  bottom: pxtow(-22);
}
</style>

<style>
.vue-waterfall-column:nth-of-type(2) {
  padding-right: 0.66666666666vw;
}

.vue-waterfall-column:nth-of-type(3) {
  padding-left: 0.66666666666vw;
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/my/gallery/list.vue